module.exports = __webpack_public_path__ + "img/down_arrow.81d05c7e.svg";